export const MICROSOFT_INTEGRATION = {
  TITLE: 'Conecta tu tenant de Microsoft 365',
  STEP1: {
    DESCRIPTION: 'Ingresa tu ID de tenant de Microsoft Entra para comenzar el proceso de conexión.',
    INPUT_LABEL: 'ID de tenant de Microsoft Entra',
    INPUT_HELP_LINK: '¿Dónde encuentro esto?',
    INPUT_ERROR: 'Por favor ingresa tu ID de tenant',
    PERMISSIONS_DISCLAIMER: 'La cuenta debe tener permisos de lectura del directorio o privilegios de administrador.',
  },
  STEP2: {
    DESCRIPTION: 'Verifica el ID a continuación. Serás redirigido a Microsoft para otorgar acceso de solo lectura.',
  },
  FOOTER: {
    CANCEL: 'Cancelar',
    CONTINUE: 'Continuar',
    BACK: 'Atrás',
    OPEN_EXTERNAL: 'Abrir Microsoft 365',
  },
  STEP_PROGRESS: {
    STEP_1: 'Paso 1: Detalles del Tenant',
    STEP_2: 'Paso 2: Revisión y Consentimiento',
  },
}
